/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Instructor course configuration service
 *
 * @file InstructorCourseConfigurationService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import { INSTRUCTOR_COURSE_CONFIGURATIONS_REQUESTED } from '../../../common/constants';

export default class InstructorCourseConfigurationService extends BaseService {
  constructor() {
    super(INSTRUCTOR_COURSE_CONFIGURATIONS_REQUESTED, 'instructorCourseConfigurationStatus');
  }

  /**
   * Handles instructor course configuration service event
   *
   * @param {*} eventName
   * @param {*} eventData
   * @returns
   */
  handleEvent(eventName, eventData = {}) {
    const { payload } = eventData;

    if (!payload.length) {
      return null;
    }

    return this.getClient('marin').post('/courses/instructor/configurations', payload);
  }

  /**
   * Handles instructor course configuration service response
   *
   * @param {*} response
   */
  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {
    const { configurations = [] } = response?.data || {};
    const bookshelf = Framework.getStoreRegistry().getStore('bookshelf');
    bookshelf.setInstructorControls(configurations);
  }

  /**
   * Handles instructor course configuration service error
   */
  // eslint-disable-next-line class-methods-use-this
  handleError() {
    // Controls stay absent; UI remains hidden until configurations are loaded
  }
}
